import { render, staticRenderFns } from "./msdsList.vue?vue&type=template&id=1447d8e3&scoped=true"
import script from "./msdsList.vue?vue&type=script&lang=js"
export * from "./msdsList.vue?vue&type=script&lang=js"
import style0 from "./msdsList.vue?vue&type=style&index=0&id=1447d8e3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1447d8e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1447d8e3')) {
      api.createRecord('1447d8e3', component.options)
    } else {
      api.reload('1447d8e3', component.options)
    }
    module.hot.accept("./msdsList.vue?vue&type=template&id=1447d8e3&scoped=true", function () {
      api.rerender('1447d8e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msds/msdsList.vue"
export default component.exports